import { render, staticRenderFns } from "./AMenuItem.vue?vue&type=template&id=d7845b66&scoped=true"
import script from "./AMenuItem.vue?vue&type=script&lang=ts"
export * from "./AMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./AMenuItem.vue?vue&type=style&index=0&id=d7845b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7845b66",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AIcon: require('/codebuild/output/src1787548897/src/app/components/atoms/Media/AIcon.vue').default,ALabel: require('/codebuild/output/src1787548897/src/app/components/atoms/Menu/ALabel.vue').default,AUnread: require('/codebuild/output/src1787548897/src/app/components/atoms/AUnread.vue').default,AArrival: require('/codebuild/output/src1787548897/src/app/components/atoms/AArrival.vue').default})
